import logoImg from '../assets/logo.png';
import React from 'react';
import './TopBar.css';

const ROLE_COLORS = {
  COO:'#1F4E79', PM:'#375623', FC:'#7B3F00',
  DEV:'#1B4F72', DEVOPS:'#4A235A', TESTER:'#922B21',
};
const ROLE_LABELS = {
  COO:'COO', PM:'Project Manager', FC:'Functional Consultant',
  DEV:'Developer', DEVOPS:'DevOps Engineer', TESTER:'Tester',
};

export default function TopBar({ state, onBack, onChangeRole, onDash, onLogout, page }) {
  const hasRole = !!state.role;

  return (
    <>
      {/* Security warning */}
      <div className="warning-banner" role="alert">
        <i className="ti ti-shield-lock" aria-hidden="true" />
        <span>
          <strong>Confidential — Internal Use Only.</strong>
          {' '}SWISO TECH proprietary content. Unauthorised access or distribution is strictly prohibited.
        </span>
      </div>

      {/* Main topbar */}
      <div className="topbar">
        <div className="topbar-left">
          <div className="topbar-logo-wrap"
            onClick={hasRole ? onDash : undefined}
            style={{ cursor: hasRole ? 'pointer' : 'default' }}
            title={hasRole ? 'Go to dashboard' : ''}
          >
            <img src={logoImg} alt="SWISO dev" className="topbar-logo" />
          </div>

          <div className="topbar-divider" />

          <div>
            <div className="topbar-title">Process Guide</div>
            <div className="topbar-sub">Employee Handbook · SDLC v2.0</div>
          </div>
        </div>

        <div className="topbar-right">
          {hasRole && (
            <div className="topbar-role-badge" style={{ borderColor: ROLE_COLORS[state.role] }}>
              <div className="topbar-role-dot" style={{ background: ROLE_COLORS[state.role] }} />
              <span className="role-badge-text">{ROLE_LABELS[state.role]}</span>
            </div>
          )}
          {hasRole && page !== 'role' && (
            <button className="btn btn-sm" onClick={onBack} title="Go back">
              <i className="ti ti-arrow-left" aria-hidden="true" />
              <span className="btn-label">Back</span>
            </button>
          )}
          {hasRole && page !== 'dash' && page !== 'role' && (
            <button className="btn btn-sm" onClick={onDash} title="Dashboard">
              <i className="ti ti-layout-dashboard" aria-hidden="true" />
              <span className="btn-label">Dashboard</span>
            </button>
          )}
          {hasRole && (
            <button className="btn btn-sm" onClick={onChangeRole} title="Change role">
              <i className="ti ti-switch" aria-hidden="true" />
              <span className="btn-label">Role</span>
            </button>
          )}
          <button className="btn btn-sm btn-logout" onClick={onLogout} title="Sign out">
            <i className="ti ti-logout" aria-hidden="true" />
            <span className="btn-label">Sign out</span>
          </button>
        </div>
      </div>
    </>
  );
}
